import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getProjectProposalsExpenditures } from 'apis/dashboard.api';

const useGetProjectProposalsExpenditures = (params, conds) => {
  const { data: projectProposalsExpenditures, ...rest } = useQuery(
    ['projectProposalsExpenditures', params],
    () => getProjectProposalsExpenditures(params),
    {
      ...conds,
    }
  );

  const data = useMemo(
    () => projectProposalsExpenditures?.data ?? [],
    [projectProposalsExpenditures]
  );

  return {
    data,
    ...rest,
  };
};

export default useGetProjectProposalsExpenditures;
